import React, { useEffect, useState } from 'react';
import close_button from '../../../assets/close_button.png';
import FcModuleStyle from '../styles/fc.module.css';
import Highcharts from 'highcharts';
require('highcharts/modules/accessibility')(Highcharts);
// require('highcharts/modules/mouse-wheel-zoom.js')(Highcharts);

const RevenueGraph = ({ type, isDecisionPopup, showDecisionPopupHandler, hideDecisionPopupHandler, simObj, setSimObj, isResult, summaryGraphData, attempt }) => {
  const [gGraphStyle, setGGraphStyle] = useState({ left: 0, top: 0 });
  const [monthlydata, setMonthlyData] = useState('');
  const [APERangeData, setAPERangeData] = useState({ "REGULAR": [], "MIDGRADE": [], "PREMIUM": [] });
  const [CostsData, setCostsData] = useState({ "monthly": [], "quarterly": [], "yearly": [] });
  const [xAxisMinMax, setXAxisMinMax] = useState({ "monthly": { min: 1, max: 31 }, "quarterly": { min: 0, max: 3 }, "yearly": { min: 0, max: 12 } });
  const [dpObject, setDpObject] = useState({});
  const [isShowD, setIsShowD] = useState(true);
  const [revenueGraphLabel, setRevenueGraphLabel] = useState("");
  const [chart, setChart] = useState(null);
  const [isOptionsUpdated,setIsOptionsUpdated] = useState(false)
  const [isStyleTagPresent, setIsStyleTagPresent] = useState(false); //Added for stylus tool text-spacing change OM-620

  let graphSettings = {}
  function getMonthDays(year, month) {
    // Months are 0-based in JavaScript (0 - January, 1 - February, ..., 11 - December)
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
  }
  const getDate = (date) => {
    let formattedDate;
    let dateObject = new Date(date);
    let options = { year: 'numeric', month: 'long'};
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      dateObject = new Date(date.replace(/-/g, "/"));
    }
    return dateObject.toLocaleDateString(navigator.language, options);
  }
  const setGraphData = () => {
    if (chart != undefined) {
      let RegularAPERange;
      let MidgradeAPERange;
      let PremiumAPERange;
      (chart && chart?.yAxis && chart?.yAxis[0]) && chart?.yAxis[0]?.update({ min: 0, max: undefined });
      //RegularAPERange
      
      RegularAPERange = simObj?.graphdata;
      RegularAPERange = (RegularAPERange != undefined ? RegularAPERange : []).map((data) => {
        return {
          x: data?.cr,
          y: data?.fi?.REGULAR?.absolutePercentageError,
          date: getDate(data.cd).replace("1,", " ").replace(/\s+/g, ' '),
          RegularAPE: data?.fi?.REGULAR?.absolutePercentageError
        }
      });
      RegularAPERange.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      setAPERangeData(prevData => ({
        ...prevData,
        REGULAR: RegularAPERange,
      }));

      if (RegularAPERange.length != (chart?.series && Array.isArray(chart.series) && chart?.series[0]?.data?.length)) {
        chart?.series && Array.isArray(chart.series) && chart?.series[0]?.setData(RegularAPERange);
      }

      if(simObj?.optionsAvailable?.MIDGRADE){
      //MidgradeAPERange
      MidgradeAPERange = simObj?.graphdata;
      MidgradeAPERange = (MidgradeAPERange != undefined ? MidgradeAPERange : []).map((data) => {
        return {
          x: data?.cr,
          y: data?.fi?.MIDGRADE?.absolutePercentageError,
          date: getDate(data.cd).replace("1,", " ").replace(/\s+/g, ' '),
          MidgradeAPE: data?.fi?.MIDGRADE?.absolutePercentageError
        }
      });
      MidgradeAPERange.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      setAPERangeData(prevData => ({
        ...prevData,
        MIDGRADE: MidgradeAPERange,
      }));
      if (MidgradeAPERange.length != (chart?.series && Array.isArray(chart.series) && chart?.series[2]?.data?.length)) {
        chart?.series && Array.isArray(chart.series) && chart?.series[1]?.setData(MidgradeAPERange);
      }
    }

    if(simObj?.optionsAvailable?.PREMIUM){
      //PremiumAPERange
      PremiumAPERange = simObj?.graphdata;
      PremiumAPERange = (PremiumAPERange != undefined ? PremiumAPERange : []).map((data) => {
        return {
          x: data?.cr,
          y: data?.fi?.PREMIUM?.absolutePercentageError,
          date: getDate(data.cd).replace("1,", " ").replace(/\s+/g, ' '),
          PremiumAPE: data?.fi?.PREMIUM?.absolutePercentageError
        }
      });
      PremiumAPERange.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      setAPERangeData(prevData => ({
        ...prevData,
        PREMIUM: PremiumAPERange,
      }));
      if (PremiumAPERange.length != (chart?.series && Array.isArray(chart.series) && chart?.series[4]?.data?.length)) {
        chart?.series && Array.isArray(chart.series) && chart?.series[2]?.setData(PremiumAPERange);
      }
    }
  }
    (simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && (chart && chart?.yAxis && chart?.yAxis[0]) && chart?.yAxis[0].update({ min: 1, max: 100 })
  }

  // const regularAPE = [6, 4, 5, 8, 3, 7, 9, 4, 6, 8, 5, 7, 6, 4, 5, 8, 3, 7, 9, 4, 6, 8, 5, 7];
  // const midgradeAPE = [3, 5, 6, 9, 4, 8, 10, 5, 7, 9, 6, 8, 7, 5, 6, 9, 4, 8, 10, 5, 7, 9, 6, 8];
  // const premiumAPE = [8, 6, 7, 10, 5, 9, 11, 6, 8, 10, 7, 9, 8, 6, 7, 10, 5, 9, 11, 6, 8, 10, 7, 9];
  function getLevelsText(simObj) {
    const levels = [];
    if (simObj?.optionsAvailable?.REGULAR) levels.push("Regular");
    if (simObj?.optionsAvailable?.MIDGRADE) levels.push("Midgrade");
    if (simObj?.optionsAvailable?.PREMIUM) levels.push("Premium");

    if (levels.length === 0) return "";

    // Make it screen reader–friendly: add “and” for the last item
    if (levels.length === 2) return `${levels[0]} and ${levels[1]}`;
    if (levels.length > 2) {
      return levels.slice(0, -1).join(", ") + " and " + levels.slice(-1);
    }
    return levels[0];
  }
  let seriesData = {
    "REGULAR" : {
      name: "Regular - Absolute Percentage Error",
      borderWidth: 1,
      borderRadius: 0,
      states: {
        hover: {
          borderWidth: 1, // Border width on hover
          borderColor: 'black' // Border color on hover
        }
      },
      data: [],
      color: "#044E61",

    },
    "MIDGRADE": {
      name: "Midgrade - Absolute Percentage Error",
      borderWidth: 1,
      borderRadius: 0,
      crisp: true,
      states: {
        hover: {
          borderWidth: 1, // Border width on hover
          borderColor: 'black' // Border color on hover
        }
      },
      data: [],
      color: "#1A83CF",

    },
    "PREMIUM": {
      name: "Premium - Absolute Percentage Error",
      borderWidth: 1,
      borderRadius: 0,
      crisp: true,
      states: {
        hover: {
          borderWidth: 1, // Border width on hover
          borderColor: 'black' // Border color on hover
        }
      },
      data: [],
      color: "#069161",
    }
  }
  graphSettings = {
    plotOptions: {
      line: {
        fillColor: {
          pattern: {
            path: {
              d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
              strokeWidth: 3
            },
            width: 10,
            height: 10,
            opacity: 0.4
          }
        }
      },
      // events: {
      //   legendItemClick: function () {
      //     return false; // Prevent default legend item click behavior
      //   }
      // },
      series: {
        //stickyTracking: false,
        marker: {
          enabled: true,
        },
        pointPlacement: "on",
        dataLabels: {
          enabled: false,
        },
        events: {
          legendItemClick: function () {
            let min = this?.chart?.series[2].yAxis.min && this?.chart?.series[2].yAxis.min;
            let max = this?.chart?.series[2].yAxis.max && this?.chart?.series[2].yAxis.max;
            setTimeout(() => {
              (this?.chart?.series && this.chart.series.every(series => !series.visible)) ? (this?.chart && this?.chart?.yAxis && this?.chart?.yAxis[0]) && this?.chart?.yAxis[0].update({ min: min, max: max }) : (this?.chart && this?.chart?.yAxis && this?.chart?.yAxis[0]) && this?.chart?.yAxis[0].update({ min: undefined, max: undefined, tickInterval: null });
            }, 100);
          }
        }
      },
      states: {
        inactive: {
          enabled: false
          //opacity:1
        },
      },
    },
    chart: {
      type: "line",
      responsive: false,
      //marginRight: 15,
      // marginTop: 3,
      height: 300,
      marginBottom: 140,
      plotBorderWidth: 1,
      panning: type === "quarterly",
      events: {
        render: function () {
          // Grab the generated SVG
          const svg = this.renderTo.querySelector('svg.highcharts-root');
          if (svg) {
            // Force role="img"
            setTimeout(() => {
            const levelsText = getLevelsText(simObj);
            svg.setAttribute('role', 'img');
            // Override aria-label with your own text
            svg.setAttribute('aria-label', `Absolute Percentage Error Range chart showing data trends for ${levelsText}.`);
            
            // Remove any existing <desc> (Highcharts adds one automatically)
            const oldDesc = svg.querySelector('desc');
            if (oldDesc) oldDesc.remove();
            
            // Add your custom <desc>
            const desc = document.createElementNS('http://www.w3.org/2000/svg', 'desc');
            desc.textContent = `This chart displays the Absolute Percentage Error (APE) range for months, comparing ${levelsText} categories.`;
            svg.insertBefore(desc, svg.firstChild);
            }, 0);
          }
        }
      }
    },
    title: null,
    legend: {
      enabled: true,
      align: "center",
      verticalAlign: "bottom",
      layout: 'horizontal',
      floating: true,
      visible: true,
      y: -10,
    },
    xAxis: {
      min: 1,
      max: 24,
      categories: ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      step: 1,
      //gridLineWidth: 1.5,
      tickInterval: 1,
      tickLength: 0,
      lineColor: '#C6C6C3',
      title: {
        text: "Month Range",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        },
      },
      labels: {
        rotation: -45,
        step: 1,
        style: {
          fontSize: '0.8em'
        }
      },
      crosshair: {
        width: 1,
        color: '#C9C8B9'
      }
    },
    yAxis: {
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 4,
      allowDecimals: false,
      gridLineColor: '#C6C6C3',
      gridLineWidth: 1,
      // Primary yAxis
      labels: {
        //format: '{value}°C',
        format: '{value}%',

      },
      title: {
        text: "APE Range",
        style: {
          fontWeight: 'bold',
          fontSize: '10px',
          color: "#000"
        }

      }

    },
    accessibility: {
      enabled: true,
      description: `This chart displays the Absolute Percentage Error (APE) range for months, comparing ${getLevelsText(simObj)} categories.`,
      pointDescriptionFormatter: function (point) {
        // Customize the aria-label for each point
        //return `Day: ${point.date}; ${(point.revenue != undefined) ? `Revenue: $${point.revenue};` : ``} ${(point.cost != undefined) ? `Cost: $${point.cost};` : ``} ${(point.costOfInternalFailures != undefined) ? `Internal failure: $${point.costOfInternalFailures};` : ``} ${(point.costOfExternalFailures != undefined) ? `External failure: $${point.costOfExternalFailures};` : ``} ${(point.costOfPreventiveInvestment != undefined) ? `Preventive investment: $${point.costOfPreventiveInvestment};` : ``} ${(point.costOfAppraisal != undefined) ? `Appraisal investment: $${point.costOfAppraisal};` : ``} ${(point.costOfotherInvestment != undefined) ? `Other Investments: $${point.costOfotherInvestment}` : ``}`;
        return `Date: ${point.date}; ${(point.RegularAPE != undefined) ? `Regular Absolute Percentage Error: ${point.RegularAPE}%;` : ``} ${(point.MidgradeAPE != undefined) ? `Midgrade Absolute Percentage Error: ${point.MidgradeAPE}%;` : ``} ${(point.PremiumAPE != undefined) ? `Premium Absolute Percentage Error: ${point.PremiumAPE}%;` : ``}`;

      },
      keyboardNavigation: {
        enabled: true, // Enable keyboard navigation
      },
      screenReaderSection: {
          beforeChartFormat: '' // disables the default label
      }
    },
    credits: {
      enabled: false
    },
    series: undefined,
    tooltip: {
      hideDelay: 0,
      shared: true,
      formatter: function () {
        return '<strong>' + (this.point.date) + '</strong><br/>' +
        this.points.map(point => '<span style="color:' + point.color + ';">●</span> ' + point.series.name + ': <strong>' + Highcharts.numberFormat(point.y, 0, ',', ',') +'%' + '</strong>').join('<br>');
      },
      /*borderWidth: 1,
      formatter: function () {
        var tooltipText = '<strong>' + (this.point.date) + '</strong><br/>';
        if (this.series.name === 'Regular - Absolute Percentage Error') {
          tooltipText += '<span style="color:' + this.point.color + ';">● </span>' + this.series.name + ': <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y, 0, ',', ',') + '%' + '</strong>';
        } else if (this.series.name === 'Midgrade - Absolute Percentage Error') {
          tooltipText += '<span style="color:' + this.point.color + ';">● </span>' + this.series.name + ': <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y, 0, ',', ',') + '%' + '</strong>';
        } else if (this.series.name === 'Premium - Absolute Percentage Error') {
          tooltipText += '<span style="color:' + this.point.color + ';">● </span>' + this.series.name + ': <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y, 0, ',', ',') + '%' + '</strong>';
        }
        return tooltipText;
      }*/
    }

  }


  useEffect(() => {
    if(type && simObj?.optionsAvailable && !isOptionsUpdated){
      let seriesdata = []
      for (const key in simObj?.optionsAvailable) {
        if (simObj?.optionsAvailable[key]) {
          seriesdata = [...seriesdata,seriesData[key]]
        }
      }
    graphSettings.series = seriesdata
    const newChart = Highcharts.chart("APE-Range", graphSettings);
    setChart(newChart);
    // if (type === "monthly" || type === "quarterly" || type === "yearly") {
    //   const g_container = FcModuleStyle['graph-container'];
    //   let gContainer = document.getElementsByClassName(`${g_container}`)[1];
    //   gContainer.setAttribute("tabindex", '-1');
    //   gContainer.focus();
    // }
    //Added for xaxis type quarterly resizable.
    if (type === "quarterly") {
      function updateCategories(type) {
        const categories = type === "quarterly" ?
          (window.innerWidth < 1218 ?
            ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'] :
            ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']) :
          [];
        if (newChart && newChart.xAxis && newChart.xAxis[0]) {
          newChart.xAxis[0].update({
            categories: categories
          });
        }
      }
      updateCategories("quarterly");
      window.addEventListener('resize', function () {
        updateCategories("quarterly");
      });
    }
    setIsOptionsUpdated(true);
  }
  }, [type,simObj?.optionsAvailable]);

  useEffect(() => {
    if (isResult && chart != undefined) {
      // chart?.series[0]?.setData([]);
      // chart?.series[1]?.setData([]);
      setSimObj((prevObj) => ({
        ...prevObj,
        graphdata: summaryGraphData,
      }));
    }
    else {
      setGraphData();
    }
    if (chart != undefined) {
      setRevenueGraphLabel(`Revenue and Cost of quality graph representing along Y-axis with ${chart?.yAxis != undefined && chart?.yAxis[0].tickInterval}% per unit scale and Time quarter along X-axis with 1 quarter per unit scale.`);
      document.querySelector("#APE-Range").setAttribute('role', `figure`);
      document.querySelector("#APE-Range .highcharts-container ").setAttribute('tabindex', '0');
    }
  }, [chart, simObj?.graphdata]);
  useEffect(() => {
    if (isResult) {
      //setGraphData();
    }
  }, [simObj, isResult, summaryGraphData])

  useEffect(() => {
    const checkStyleTag = () => {
      const styleTag = document.querySelector('style.stylus');
      setIsStyleTagPresent(!!styleTag);  // Updates the state to true if the tag is found, false otherwise
    };

    // Call the check function when the component mounts
    checkStyleTag();

    // Optionally, if the tag might be dynamically added, use a MutationObserver or setInterval
    const intervalId = setInterval(checkStyleTag, 500); // Check every 500ms
    return () => clearInterval(intervalId);  // Clean up interval when component unmounts
  }, []);
  useEffect(()=>{
    if(chart != undefined){
      // Update the legend dynamically
      chart.update({
        legend: {
            itemStyle: {
                fontSize: isStyleTagPresent ? '0.7em' : '0.8em',
            },
        },
    });
    }
  },[chart,isStyleTagPresent])
  return (
    <div className={`${FcModuleStyle['graph-container']}`} >
      {!simObj?.graphdata?.length && <div className={`${FcModuleStyle['nodata-alert-APE']}`}>Absolute Percentage Error Range will appear here as the simulation runs</div>}
      <span></span>
      {/* <a href="#" onClick={(e)=> e.preventDefault()} aria-label="Legends: line with round bullet for Revenue and line with Rhombus got Cost of Quality" className="sr-only"></a> */}
      <div id="APE-Range" className={`${FcModuleStyle['revenue-graph']}`} aria-label={revenueGraphLabel} role='figure'>
      </div>
    </div>
  )
}

export default RevenueGraph